/**
 * @file Route: singleproduct
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import { Header } from "components/Header/Info";
import { $, $all, forEach, on } from "@olmokit/dom";
import scrollLock from "@olmokit/core/scroll/lock";
// import { clickCta } from "components/Dl";
import dialogProduct from "components/Dialog/Product";
import { PageCollection } from "components/Page/Collection";
import "./index.scss";

console.log("Route singleproduct/index.js mounted.");

Header();
PageCollection();

scrollLock.disable(dialogProduct.$cage);

// const ctas = $all(".dlClickCta");
// if (ctas) {
//   forEach(ctas, c => {
//     on(c, "click", () => {
//       clickCta(c.getAttribute("data-link"), c.getAttribute("data-label"));
//     });
//   });
// }